import { useEffect } from "react";
import api from "../lib/api";
import { useSiteInfo } from "../context/SiteInfoContext";

let installed = false;

export default function LiveChat() {
  const { info } = useSiteInfo();
  const concierge = info?.email || "hello@glitterzshc.com";
  useEffect(() => {
    if (installed) return;
    api.get("/livechat").then(({ data }) => {
      if (!data?.enabled || !data.property_id) return;
      installed = true;
      if (data.provider === "tawk") {
        const s = document.createElement("script");
        s.async = true;
        s.src = `https://embed.tawk.to/${data.property_id}/${data.widget_id || "default"}`;
        s.charset = "UTF-8";
        s.setAttribute("crossorigin", "*");
        document.body.appendChild(s);
      } else if (data.provider === "crisp") {
        window.$crisp = []; window.CRISP_WEBSITE_ID = data.property_id;
        const s = document.createElement("script");
        s.async = true; s.src = "https://client.crisp.chat/l.js";
        document.body.appendChild(s);
      }
    }).catch(() => {});
  }, []);

  // Fallback floating concierge link (visible until a real widget loads on top of it)
  return (
    <a href={`mailto:${concierge}?subject=Concierge%20enquiry`}
       data-testid="concierge-fallback"
       className="fixed left-4 bottom-4 z-30 hidden md:inline-flex items-center gap-2 bg-white border border-neutral-900 px-4 py-3 text-[11px] tracking-[0.22em] uppercase shadow-sm hover:bg-neutral-900 hover:text-white transition-colors">
      <span className="w-2 h-2 rounded-full bg-[var(--gold)]" /> Concierge
    </a>
  );
}
